export interface EnquiryFields {
  name: string;
  city: string;
  postcode: string;
  category: string;
  reference: string;
  width: string;
  height: string;
  unit: string;
  shape: string;
  colours: string;
  wording: string;
  budget: string;
  preferredDate: string;
  description: string;
}

export function buildEnquiryMessage(
  d: EnquiryFields,
  enquiryId: string,
  referenceUrl: string | null
): string {
  const lines: string[] = [
    "Hi Tuft and Tale! I'd like to enquire about a custom rug.",
    "",
    `Enquiry ID: ${enquiryId}`,
    `Name: ${d.name}`,
  ];
  const loc = [d.city, d.postcode].map((s) => s.trim()).filter(Boolean).join(" / ");
  if (loc) lines.push(`Location: ${loc}`);
  const design = [d.category, d.reference].map((s) => s.trim()).filter(Boolean).join(" / ");
  if (design) lines.push(`Design: ${design}`);
  const size = [d.width.trim(), d.height.trim()].filter(Boolean).join(" × ");
  if (size) lines.push(`Size: ${size}${d.unit ? " " + d.unit : ""}`);
  if (d.shape.trim()) lines.push(`Shape: ${d.shape.trim()}`);
  if (d.colours.trim()) lines.push(`Colours: ${d.colours.trim()}`);
  if (d.wording.trim()) lines.push(`Text or name: ${d.wording.trim()}`);
  if (d.budget.trim()) lines.push(`Budget: ${d.budget.trim()}`);
  if (d.preferredDate.trim()) lines.push(`Preferred date: ${d.preferredDate.trim()}`);
  if (d.description.trim()) lines.push(`My idea: ${d.description.trim()}`);
  if (referenceUrl) lines.push(`Uploaded references: ${referenceUrl}`);
  return lines.join("\n");
}
